export default __webpack_public_path__ + "static/media/somethingWentWrong.2b84c700.svg";